import React from 'react';
import { ContentField as ContentFieldType } from '../../types/optionTypes';

interface ContentFieldProps {
    field: ContentFieldType;
}

export const ContentField: React.FC<ContentFieldProps> = ({ field }) => {
    if (!field.active || !field.value) {
        return null;
    }

    return (
        <div className="w-full">
            {field.label && (
                <label className="block text-sm font-medium text-gray-800 mb-2">
                    {field.label}
                </label>
            )}

            <div
                className="text-sm text-gray-700 leading-relaxed bg-blue-50 border border-blue-200 rounded-md p-3"
                dangerouslySetInnerHTML={{ __html: field.value }}
            />
        </div>
    );
};
